import React from 'react';
import {globalT} from "../../lang";
import IntlMessage from '../IntlMessage';

const paragraphStyle: React.CSSProperties = {
    textAlign: 'justify'
}

const BaseConvention = () => {
    return (
        <div className='pb-4 px-sm-4 px-0'>
            <div className='p-15'>
                <p className='fw-bold' style={{ fontSize: 20, marginBottom: 30 }}>{<IntlMessage id="convention.title" />}</p>
                <p style={paragraphStyle}>{<IntlMessage id="convention.paragraph1" />}</p>
                <p style={paragraphStyle} dangerouslySetInnerHTML={{ __html: globalT("convention.paragraph2") }} />
                <p style={paragraphStyle} dangerouslySetInnerHTML={{ __html: globalT("convention.paragraph3") }} />
                <p style={paragraphStyle} dangerouslySetInnerHTML={{ __html: globalT("convention.paragraph4") }} />
                <p style={paragraphStyle} dangerouslySetInnerHTML={{ __html: globalT("convention.paragraph5") }} />
                <p style={paragraphStyle} dangerouslySetInnerHTML={{ __html: globalT("convention.paragraph6") }} />
                <p style={paragraphStyle} dangerouslySetInnerHTML={{ __html: globalT("convention.paragraph7") }} />
                <p style={paragraphStyle} dangerouslySetInnerHTML={{ __html: globalT("convention.paragraph8") }} />
                <p style={paragraphStyle} dangerouslySetInnerHTML={{ __html: globalT("convention.paragraph9") }} />
                <p style={paragraphStyle} dangerouslySetInnerHTML={{ __html: globalT("convention.paragraph10") }} />
            </div>
        </div>
    );
};

export default BaseConvention;
